import { render, staticRenderFns } from "./VenueCateringPage.vue?vue&type=template&id=0530c074"
import script from "./VenueCateringPage.vue?vue&type=script&lang=ts"
export * from "./VenueCateringPage.vue?vue&type=script&lang=ts"
import style0 from "./VenueCateringPage.vue?vue&type=style&index=0&id=0530c074&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports